import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { consentActions } from 'redux/slices/consent.slice';
import { useAppDispatch } from 'redux/store-hooks';

const ConsentActionsInitializer = () => {
  const dispatch = useAppDispatch();
  const [params] = useSearchParams();
  const key = params.get('key');

  useEffect(() => {
    if (key) {
      dispatch(consentActions.setKey(key));
    }
  }, [dispatch, key]);

  return null;
};

export default ConsentActionsInitializer;
